// Onboarding stav drží localStorage per user — žiadny zásah do backendu.
// Skutočný progres (pracoviská/zamestnanci/prvý príchod) sa vždy deriva z dát,
// tu sú len UI flagy (videl welcome, dokončil/preskočil wizard, tour, oslava).

const storageKey = (userId) => `effzone_onboarding_${userId}`;

export const getOnboardingState = (userId) => {
    if (!userId) return {};
    try {
        return JSON.parse(localStorage.getItem(storageKey(userId))) || {};
    } catch (e) {
        return {};
    }
};

export const updateOnboardingState = (userId, patch) => {
    if (!userId) return;
    try {
        const next = { ...getOnboardingState(userId), ...patch };
        localStorage.setItem(storageKey(userId), JSON.stringify(next));
    } catch (e) {
        // localStorage nedostupné (private mode) — onboarding sa len zobrazí znova
    }
};

// Jednoduchý event bus — checklist na dashboarde vie spustiť wizard/tour
// bez prepojenia cez context.
export const START_WIZARD_EVENT = 'effzone:start-wizard';
export const START_TOUR_EVENT = 'effzone:start-tour';

export const requestWizard = () => window.dispatchEvent(new CustomEvent(START_WIZARD_EVENT));
export const requestTour = () => window.dispatchEvent(new CustomEvent(START_TOUR_EVENT));
